import "@/App.css";
import { BrowserRouter, Routes, Route, Navigate } from "react-router-dom";
import { Layout } from "@/components/Layout";
import { Home } from "@/pages/Home";
import { Services } from "@/pages/Services";
import { RapidDiagnostic } from "@/pages/RapidDiagnostic";
import { Demo } from "@/pages/Demo";
import { Intake } from "@/pages/Intake";
import { IntakeSuccess } from "@/pages/IntakeSuccess";
import { IntakeCancelled } from "@/pages/IntakeCancelled";
import { DiagnosticPreview } from "@/pages/DiagnosticPreview";
import { Procurement } from "@/pages/Procurement";
import { FAQ } from "@/pages/FAQ";
import { Contact } from "@/pages/Contact";
import { Exports } from "@/pages/Exports";
import { SampleMemo } from "@/pages/SampleMemo";
import { Atlas } from "@/pages/Atlas";
import { DeliveryModel } from "@/pages/DeliveryModel";
import { Legal } from "@/pages/Legal";
import { ThankYou } from "@/pages/ThankYou";
import { Auth } from "@/pages/Auth";
import Portal from "@/pages/Portal.tsx";

function App() {
  return (
    <div className="App">
      <BrowserRouter>
        <Layout>
          <Routes>
            <Route path="/" element={<Home />} />
            <Route path="/services" element={<Services />} />
            <Route path="/rapid-diagnostic" element={<RapidDiagnostic />} />
            <Route path="/demo" element={<Demo />} />
            <Route path="/intake" element={<Intake />} />
            <Route path="/intake/success" element={<IntakeSuccess />} />
            <Route path="/intake/cancelled" element={<IntakeCancelled />} />
            <Route path="/diagnostic-preview" element={<DiagnosticPreview />} />
            <Route path="/procurement" element={<Procurement />} />
            <Route path="/faq" element={<FAQ />} />
            <Route path="/contact" element={<Contact />} />
            <Route path="/exports" element={<Exports />} />
            <Route path="/sample-memo" element={<SampleMemo />} />
            <Route path="/atlas" element={<Atlas />} />
            <Route path="/delivery-model" element={<DeliveryModel />} />
            <Route path="/legal" element={<Legal />} />
            <Route path="/thank-you" element={<ThankYou />} />
            <Route path="/auth" element={<Auth />} />
            <Route path="/portal" element={<Portal />} />

            {/* legacy / removed routes */}
            <Route path="/about" element={<Navigate to="/" replace />} />

            {/* catch-all */}
            <Route path="*" element={<Navigate to="/" replace />} />
          </Routes>
        </Layout>
      </BrowserRouter>
    </div>
  );
}

export default App;